module.exports = __webpack_public_path__ + "img/promo-3.24c4c5ac.png";